<template>
  <div class="box animated fadeIn">
    <div class="outline">
      <div v-if="Switch" style="height: 100%;position: relative;">
        <div class="rightCon" :style="{ width:'37%',marginLeft:'63%'}">
          <div class="HeaderTitle">
            <div>{{Container.video.title }}</div>
          </div>
          <div v-for="item in Container.video.list">
            <h1 class="title" v-html="item.title"></h1>
            <!--<div class="dvline"></div>-->
            <p class="text" v-html="item.body"></p>
          </div>
          <div class="switchbtn" v-on:click="SwitchGO"> 衛教資訊
            <Icon size="30" type="ios-arrow-forward"/>
          </div>
        </div>


        <div class="leftCon">
          <div v-if="Type" class="img" :style="Cover">
          </div>
          <div v-else class="videos" style="display: flex;justify-content: center;align-items: center">
            <div v-if="VideoPlaybtn" class="playbtn" style="position: absolute;z-index: 11">
              <Icon size="60" type="md-play" style="margin-left: 10px" v-on:click="PlayEvent"/>
            </div>

            <Media
              :kind="'video'"
              :controls="false"
              :src="[require('../../static/' + Container.video.videosrc)]"
              :autoplay="true"
              :style="{width: '100%',height:'100%'}"
              :ref="'VDPlayer'"
              :loop="true"
              @ended="PauseEvent()"
            >
            </Media>
          </div>
        </div>
      </div>

      <div v-else style="height: 100%;position: relative;">
        <div class="rightCon" :style="{ width:'70%',marginLeft:'30%'}">

          <div class="HeaderTitle">
            <div>{{Container.text.title }}</div>
            <div style="font-size: 1.5rem">衛教資訊</div>
          </div>
          <ul style="margin-left:20px">
            <li v-for="item in Container.text.list" style="font-size: 2rem">
              <h1 class="title" v-html="item.title"></h1>
              <!--<div class="dvline"></div>-->

              <p v-if=" item.body.constructor!==Array " class="text" v-html="item.body "></p>
              <div v-if=" item.body.constructor==Array " class="text">
                <ul  style="list-style-type: decimal;margin-left:20px">
                  <li v-for="row in item.body">{{row}}</li>
                </ul>
              </div>
            </li>
          </ul>

          <div class="switchbtn animated fadeInRight delay-1s" v-on:click="SwitchGO">
            <Icon size="30" type="ios-arrow-back"/>
            {{ Container.text.videobtnname}}
          </div>
        </div>


        <div class="leftCon" :style="{ width:'30%'}">
          <div class="img" :style="{backgroundImage: 'url(' + require('../assets/' +Container.text.videoImg) + ')'}">

            <div class="playbtn" v-on:click="Switch = !Switch">
              <Icon size="60" type="md-play" style="margin-left: 10px" />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import Media from '@dongido/vue-viaudio'

export default {
  name: 'HelloWorld',
  components: {Media},
  props: {
    Type: Boolean,
    ImgUrl: String,
    Container: Object,

  },
  data () {
    return {
      VideoPlaybtn: false,
      Switch: false,
      Cover: {backgroundImage: 'url(' + require('../assets/' + this.ImgUrl) + ')'},

    }
  },
  mounted () {

  },

  methods: {
    goBack () {
      this.$router.push('/Home')
    },
    PlayEvent () {
      // this.$refs.VDPlayer.pause()

      this.$refs.VDPlayer.play()
      this.VideoPlaybtn = false

    },
    PauseEvent () {

      this.VideoPlaybtn = true

      this.$refs.VDPlayer.pause()
    },
    SwitchGO () {
      this.Switch = !this.Switch
    }

  }
}
</script>

<style scoped lang="scss">
  .HeaderTitle{
    line-height: 3rem;
    display: flex;
    justify-content: space-between;
    font-size: 2rem;
    border-bottom: 1px solid #fff;
    margin-bottom: 30px;
    padding-bottom: 20px;
  }
  .playbtn {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 130px;
    background-color: black;
    color: #fff;
    width: 150px;
    height: 150px;
  }

  .switchbtn {

    margin-top: 60px;
    text-align: center;
    border-radius: 30px;
    border: 1px solid #fff;
    line-height: 50px;
    font-size: 1.5rem;
    color: #fff;
    width: 180px;
    height: 50px;

  }

  .dvline {
    height: 1px;
    background-color: aliceblue;
    margin: 20px;
  }

  .title {
    font-size: 1.8rem;
    font-weight: 500;
  }

  .text {
    margin-top: 1rem;
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
    line-height: 2.6rem;
    font-weight: 400;
    text-align: justify;
  }

  .img {

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    /*position: relative;*/
    background-color: #999;
    /*background-size: 100%;*/
  }

  .leftCon {

    width: 63%;
    height: 100%;
  }

  .rightCon {
    z-index: 1;
    color: #fff;
    text-align: left;
    padding: 30px 60px;
    float: right;
    width: 37%;
    height: 100%;
    background-color: #555555;
    position: absolute;
  }

  .outline {
    /*background-color: blueviolet;*/
    height: 100%;
  }

  .box {
    /*position: absolute;*/
    /*background-color: black;*/
    padding: 120px 60px 50px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;

  }

  .videos {

    width: 100%;
    height: 100%;
    background-color: black;
  }

</style>
